import React from 'react';
import { renderNewVigboAlbumModal } from 'reactApp/sections/VigboPage/renderNewVigboAlbumModal';
import { Button, ButtonSizeMode } from 'reactApp/ui/Button/Button';

export function LinkedBottomContent() {
    const hadleVigboGalleryCreate = () => {
        renderNewVigboAlbumModal({ navigateToAlbum: true });
    };

    return (
        <Button primary onClick={hadleVigboGalleryCreate} theme="octavius" sizeMode={ButtonSizeMode.small}>
            Создать галерею
        </Button>
    );
}
